/**
 * Parses and conditionally transforms an incoming message object.
 *
 * If the message has a type of 'MESSAGE' and its text property matches one of the predefined mediaChangeTexts,
 * it returns a modified version of the message object with the type changed to 'COMMAND', the action set to 'mediaChange',
 * and the text modified to remove the 'MEDIA_CHANGE:' prefix.
 *
 * Otherwise, it returns the original message object unchanged.
 */
export function parseIncomingMessage (message) {
  const mediaChangeTexts = [ 'MEDIA_CHANGE:video-off', 'MEDIA_CHANGE:video-on', 'MEDIA_CHANGE:audio-off', 'MEDIA_CHANGE:audio-on' ]

  if (message.type === 'MESSAGE' && mediaChangeTexts.indexOf(message.text) !== -1) {
    return {
      ...message,
      ...{
        type: 'COMMAND',
        action: 'mediaChange',
        text: message.text.replace('MEDIA_CHANGE:', ''),
      },
    }
  }

  return message
}
